import styled, { keyframes } from 'styled-components/macro';

const placeholderAnimation = keyframes`
  0%{
    opacity: 1;
  }
  50%{
    opacity: .3;
  }
  100%{
    opacity: 1;
  }
`;

export const NameAndRoleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  order: ${({ invert }) => (invert ? 1 : 3)};
  text-align: ${({ invert }) => (invert ? 'right' : 'left')};
  color: ${({ textColor }) => textColor || 'inherit'};
  padding: 0px 10px;
  flex-grow: 1;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  order: 2;
  object-fit: cover;
  object-position: 50% 0%;
`;

export const ImagePlaceholder = styled.div`
  width: 82px;
  height: 92px;
  order: 2;
  background-color: ${({ theme }) => theme.darkWithLowOpacity};
  animation: ${placeholderAnimation} 2s linear infinite;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    width: 64px;
    height: 70px;
  }
`;

export const ImageContainer = styled.div`
  width: 82px;
  height: 92px;
  max-width: 82px;
  min-width: 82px;
  order: 2;
  display: flex;
  flex-direction: row;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    width: 64px;
    height: 70px;
    max-width: 64px;
    min-width: 64px;
  }

  svg {
    top: 0;
    left: 0;
    margin-right: -10px;
  }
`;

export const ImageEmpty = styled.div`
  width: 53px;
  height: 53px;
  order: 2;
  background-color: ${({ theme }) => theme.darkWithLowOpacity};
`;

export const Title = styled.span`
  font-family: ${({ theme }) => theme.primaryFontBold};
  font-size: 13px;
  margin-bottom: 4px;
  display: block;
  text-transform: uppercase;
`;

export const TitlePlaceholder = styled.div`
  display: inline-block;
  width: 80%;
  background-color: ${({ theme }) => theme.darkWithLowOpacity};
  height: 10px;
  animation: ${placeholderAnimation} 2s linear infinite;
`;

export const Subtitle = styled.span`
  font-weight: normal;
  display: block;
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.primaryFontLight};
  font-size: 9px;
`;

export const SubtitlePlaceholder = styled.div`
  display: inline-block;
  width: 60%;
  background-color: ${({ theme }) => theme.darkWithLowOpacity};
  height: 10px;
  animation: ${placeholderAnimation} 2s linear infinite;
`;
